<template>
<div v-el:modal class="modal">
  <div class="modal-dialog modal-{{size}}">
    <div class="modal-content">
      <slot name="content"></slot>
    </div>
  </div>
</div>
</template>


<script lang="babel">
import $ from 'jquery'

export default {
  name: 'modal-base',
  props: {
    isShown: {
      type: Boolean,
      twoWay: true,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator (value) {
        return ['lg', 'md', 'sm'].includes(value)
      },
    },
  },
  watch: {
    isShown(val, oldVal) {
      if (val) {
        $(this.$els.modal).modal('show')
      } else {
        $(this.$els.modal).modal('hide')
      }
    },
  },
  ready () {
    $(this.$els.modal).modal({
      backdrop: 'static',
      show: false,
    })

    this._shownHanlder = e => {
      this.isShown = true
      this.$dispatch('modal-shown', this)
    }
    this._hiddenHanlder = e => {
      this.isShown = false
      this.$dispatch('modal-hidden', this)
    }
    $(this.$els.modal).on('shown.bs.modal', this._shownHanlder)
    $(this.$els.modal).on('hidden.bs.modal', this._hiddenHanlder)
  },
  beforeDestroy () {
    $(this.$els.modal).off('shown.bs.modal', this._shownHanlder)
    $(this.$els.modal).off('hidden.bs.modal', this._hiddenHanlder)
  },
  methods: {
    show() {
      this.isShown = true
    },
    hide() {
      this.isShown = false
    },
  },
}
</script>

<style lang="sass" scoped>
.modal-dialog {
  min-width: 600px;
  width: 95%;
  height: 95%;
}

</style>



// WEBPACK FOOTER //
// modal.vue?53d240b8